"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var SearchOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M437.333 85.333c194.411 0 352 157.59 352 352a350.507 350.507 0 01-74.752 216.896l185.984 186.006a42.667 42.667 0 01-57.621 62.826l-2.71-2.496L654.23 714.581a350.507 350.507 0 01-216.896 74.752c-194.41 0-352-157.589-352-352s157.59-352 352-352zm0 85.334c-147.285 0-266.666 119.381-266.666 266.666S290.048 704 437.333 704 704 584.619 704 437.333 584.619 170.667 437.333 170.667z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
SearchOutlined.displayName = "SearchOutlined";
var _default = exports["default"] = SearchOutlined;